import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoginRequest } from '../../features/login/models/login-request.model';
import { LoginResponse } from '../../features/login/models/login-response.model';

export interface ResetPasswordRequest {
  username: string;
}

export interface SetNewPasswordRequest {
  userId: string;
  hash: string;
  password: string;
  confirmPassword: string;
}

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<{ request: LoginRequest }>(),
    'Login Success': props<{ response: LoginResponse }>(),
    'Login Failure': props<{ error: string }>(),

    'Token Login': props<{ token: string }>(),
    'Token Login Success': props<{ response: LoginResponse }>(),
    'Token Login Failure': props<{ error: string }>(),

    'Restore Session': props<{ token: string }>(),
    'Restore Session Success': props<{ token: string }>(),
    'Restore Session Failure': emptyProps(),
    'Mark Loaded': emptyProps(),

    'Change Hotel': props<{ hotelId: string }>(),
    'Change Hotel Success': props<{ response: LoginResponse }>(),
    'Change Hotel Failure': props<{ error: string }>(),
    Logout: emptyProps(),
    'Refresh Token Success': props<{ response: LoginResponse }>(),

    'Reset Password': props<{ request: ResetPasswordRequest }>(),
    'Reset Password Success': emptyProps(),
    'Reset Password Failure': props<{ error: string }>(),

    'Set New Password': props<{ request: SetNewPasswordRequest }>(),
    'Set New Password Success': emptyProps(),
    'Set New Password Failure': props<{ error: string }>(),
  },
});
